import React from 'react';
import ConfirmIcon from 'components/Icons/ConfirmIcon';
import { useTranslation } from 'react-i18next';
import WarningBlackIcon from 'components/Icons/WarningBlackIcon';
import Loader from 'components/Loader';

interface Props {
  handleConfirm(): void;
  isLoading: boolean;
}

const ConfirmDeactivationTeam: React.FC<Props> = ({ handleConfirm, isLoading }) => {
  const { t } = useTranslation('modalBeneficiariesDeactivation');
  return (
    <div className="success-wrapper" data-testid="success-many-modal">
      <div className="icon-wrapper-confirm">
        <ConfirmIcon />
      </div>
      <span className="title-success deactivate-title"> {t('handle_confirm_deactivate')}</span>
      <div className="description-container">
        <WarningBlackIcon />
        <span className="subtitle deactive-subtitle">{t('handle_confirm_description')}</span>
      </div>
      <button
        type="button"
        className="ok-button deactivate-confirm"
        onClick={handleConfirm}
        data-testid="confirm-deactivation-button"
        disabled={isLoading}
      >
        {isLoading ? <Loader small /> : t('confirm')}
      </button>
    </div>
  );
};

export default ConfirmDeactivationTeam;
